import { connect } from 'react-redux';
import SessionLength from './SessionLength';

const mapStateToProps = (state: any) => ({
  isLoading: state.authSettings.organization.isLoading,
  failed: state.authSettings.organization.failed,
  sessionLength: state.authSettings.organization.session.inactivityTimeout,
});

export default connect(mapStateToProps, null)(SessionLength);
